<template>
  <AllegroJsonForm
    title="Edytuj informacje o bezpieczeństwie"
    crumbLabel="Edycja informacji o bezpieczeństwie produktu"
    :settingsCrumb="true"
    submitAction="updateAllegroSafetyInformation"
    submitGetter="getAllegroSafetyInformationUpdateData"
    loadAction="getAllegroSafetyInformation"
    loadGetter="getAllegroSafetyInformationData"
    :isUpdate="true"
    backRoute="/allegro/accounts"
    :modelPermission="modelPermission"
    :fields="fields"
  />
</template>

<script>
import AllegroJsonForm from "./AllegroJsonForm.vue";
import { allegroSafetyInformationPermissionsConst } from "../../constants/allegroConstants";

export default {
  name: "AllegroSafetyInformationUpdate",
  components: { AllegroJsonForm },
  data() {
    return {
      modelPermission: allegroSafetyInformationPermissionsConst.update,
      fields: [
        {
          key: "text",
          label: "Opis bezpieczeństwa",
          type: "textarea",
          required: true,
        },
      ],
    };
  },
};
</script>
